import {useEffect, useState} from 'react';

import {sortAiAssistData} from 'src/modules/admin/ai-assist-usage/utils/sortAiAssistData';
import {getAllAiReviewUsageBasicInfo} from 'src/openapi/apis/ChangeRequestAiUsageControllerApi';
import {AiReviewUsageBasicInfo} from 'src/openapi/models/AiReviewUsageBasicInfo';
import {useAppDispatch} from 'src/store';

import {Icons} from '@pb/kit-component-icon';
import {Status, usePushNotification} from '@pb/kit-component-push-notification';

export const useAllAiReviewUsageBasicInfo = () => {
    const dispatch = useAppDispatch();
    const {onCreateNote} = usePushNotification();
    const [isLoading, setIsLoading] = useState(false);
    const [aiAssistData, setAiAssistData] = useState<AiReviewUsageBasicInfo[]>([]);

    useEffect(() => {
        setIsLoading(true);
        const fetchData = async () => {
            const response = await dispatch(getAllAiReviewUsageBasicInfo());

            if (response.payload?.success) {
                setAiAssistData(sortAiAssistData(response.payload.data));
            }

            if (response.payload?.error) {
                onCreateNote({
                    id: 'getAllAiReviewUsageBasicInfoError',
                    status: Status.ERROR,
                    message: response.payload.data?.message,
                    buttonProps: {iconProps: {type: Icons.CLOSE}},
                    autoHideTimeout: 10000,
                });
            }

            setIsLoading(false);
        };

        fetchData();
    }, [dispatch, onCreateNote]);

    return {aiAssistData, isLoading};
};
